import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {Navigate , useNavigate} from "react-router-dom";

import { GetProductCategoryListDropDownSlice, GetSubCategoryProductSlice } from "../../../redux/features/ProductCategorySlice";
import { AddMetaDataSlice } from "../../../redux/features/MetaDataManagementSlice";
import Editor from "../../../common/Editor/Editor";

const AddMetaSubCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [categoryList, setCategoryList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);

  /* 🔹 FORM STATE */
  const [form, setForm] = useState({
    categoryId: "",
    subcategoryId: "",
    type: "",
    title: "",
    description: "",
    keywords: "",
    content: ""
  });


  /* 🔹 CATEGORY LIST */
  useEffect(() => {
    dispatch(GetProductCategoryListDropDownSlice()).then((res) => {
      setCategoryList(res?.payload?.data || []);
    });
  }, [dispatch]);

  /* 🔹 SUB CATEGORY LIST (DEPENDENT) */
  useEffect(() => {
    if (form.categoryId) {
      dispatch(GetSubCategoryProductSlice(form.categoryId)).then((res) => {
        setSubcategoryList(res?.payload?.data?.subcategory || []);
      });
    } else {
      setSubcategoryList([]);
      setForm((prev) => ({ ...prev, subcategoryId: "" }));
    }
  }, [form.categoryId, dispatch]);

  /* 🔹 INPUT CHANGE */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  /* 🔹 EDITOR CHANGE */
  const handleEditorChange = (updatedContent) => {
    setForm((prev) => ({ ...prev, content: updatedContent }));
  };

  /* 🔹 SUBMIT */
  const handleSubmit = () => {
    const payload = { ...form };
    console.log("✅ Meta SubCategory Payload 👉", payload);

    dispatch(AddMetaDataSlice(payload))
      .then((res) => {
        if (res?.payload?.status) {
          setForm({
            categoryId: "",
            subcategoryId: "",
            type: "",
            title: "",
            description: "",
            keywords: "",
            content: "",
            status: "active",
          });

          // ✅ REDIRECT TO TABLE PAGE
        navigate("/MetadataManagement/SubCategoryMetaData");

        } else {
          alert("Failed to save");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong!");
      });
  };

  const typeOptions = [
    { label: "Sub Category", value: "SUBCATEGORY" },
  ];

  return (
    <div className="Small-Wrapper mt-4">

      {/* CATEGORY */}
      <div className="form-group">
        <label>Category</label>
        <select
          className="form-control"
          name="categoryId"
          value={form.categoryId}
          onChange={handleChange}
        >
          <option value="">-- Select Category --</option>
          {categoryList.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.categoryName}
            </option>
          ))}
        </select>
      </div>

      {/* SUB CATEGORY */}
      <div className="form-group">
        <label>SubCategory</label>
        <select
          className="form-control"
          name="subcategoryId"
          value={form.subcategoryId}
          onChange={handleChange}
          disabled={!subcategoryList.length}
        >
          <option value="">-- Select SubCategory --</option>
          {subcategoryList.map((sub) => (
            <option key={sub._id} value={sub._id}>
              {sub.subcategoryName}
            </option>
          ))}
        </select>
      </div>

      {/* TYPE */}
      <div className="form-group">
        <label>Type</label>
        <select
          className="form-control"
          name="type"
          value={form.type}
          onChange={handleChange}
        >
          <option value="">-- Select Type --</option>
          {typeOptions.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      {/* TITLE */}
      <div className="form-group">
        <label>Title</label>
        <input
          className="form-control"
          name="title"
          value={form.title}
          onChange={handleChange}
        />
      </div>

      {/* DESCRIPTION */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          className="form-control"
          name="description"
          value={form.description}
          onChange={handleChange}
        />
      </div>

      {/* KEYWORDS */}
      <div className="form-group">
        <label>Keywords</label>
        <input
          className="form-control"
          name="keywords"
          value={form.keywords}
          onChange={handleChange}
        />
      </div>

      {/* CONTENT (MAIN EDITOR) */}
      <div className="col-sm-12">
        <div className="form-group">
          <label>Content</label>
          <Editor
            setContentState={setForm}
            type="content"
            content={form.content}
            form={form}
          />
        </div>
      </div>

      <button className="Button mt-3" onClick={handleSubmit}>
        Add
      </button>
    </div>
  );
};

export default AddMetaSubCategory;
